module.exports = __webpack_public_path__ + "static/media/add_agent_active.0a20a978.svg";